import { render, staticRenderFns } from "./ProductsCreate.vue?vue&type=template&id=5e149246&scoped=true"
import script from "./ProductsCreate.vue?vue&type=script&lang=js"
export * from "./ProductsCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductsCreate.vue?vue&type=style&index=0&id=5e149246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e149246",
  null
  
)

export default component.exports